import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

const AUTH_STORAGE_KEY = 'ah-dash-user';

@Injectable({ providedIn: 'root' })
export class DashboardApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.AH_DASH_API_SERVER_01_FULL_URL.replace(/\/+$/, '');

  readonly isFakeShowcase = environment.IS_FAKE_SHOWCASE;

  private authOptions() {
    const accessToken = this.accessToken();
    const selectedScopeId = this.selectedScopeId();
    let headers = new HttpHeaders();

    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    if (selectedScopeId) {
      headers = headers.set('X-Selected-Scope-Id', selectedScopeId);
    }

    return headers.keys().length > 0 ? { headers } : undefined;
  }

  private readStoredAuth(): { accessToken?: unknown; selectedScopeId?: unknown } | null {
    try {
      const stored = localStorage.getItem(AUTH_STORAGE_KEY) ?? sessionStorage.getItem(AUTH_STORAGE_KEY);
      if (!stored) {
        return null;
      }

      return JSON.parse(stored) as { accessToken?: unknown; selectedScopeId?: unknown };
    } catch {
      return null;
    }
  }

  private accessToken(): string | null {
    const parsed = this.readStoredAuth();
    return typeof parsed?.accessToken === 'string' && parsed.accessToken
      ? parsed.accessToken
      : null;
  }

  private selectedScopeId(): string | null {
    const parsed = this.readStoredAuth();
    return typeof parsed?.selectedScopeId === 'string' && parsed.selectedScopeId
      ? parsed.selectedScopeId
      : null;
  }

  get<T>(path: string) {
    return this.http.get<T>(`${this.baseUrl}${path}`, this.authOptions());
  }

  post<T>(path: string, body: unknown) {
    return this.http.post<T>(`${this.baseUrl}${path}`, body, this.authOptions());
  }

  patch<T>(path: string, body: unknown) {
    return this.http.patch<T>(`${this.baseUrl}${path}`, body, this.authOptions());
  }

  delete<T>(path: string) {
    return this.http.delete<T>(`${this.baseUrl}${path}`, this.authOptions());
  }
}
